import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Teach tailwind-merge the custom type scale and radii (tokens.css). Without this, `text-caption`
// looks like a colour and is dropped when a `text-<colour>` follows it.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['caption', 'small', 'body', 'title', 'large', 'h3', 'h2', 'h1'],
      radius: ['control', 'card', 'dialog'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
